var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.095 3.30176H9.905C7 3.30176 6.35833 4.74842 5.985 6.52176L4.66666 12.8334H23.3333L22.015 6.52176C21.6417 4.74842 21 3.30176 18.095 3.30176Z",
    stroke: "#06C7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.655 23.1233C25.7833 24.4883 24.6867 25.6666 23.2867 25.6666H21.0933C19.8333 25.6666 19.6583 25.1299 19.4367 24.4649L19.2033 23.7649C18.8767 22.8083 18.6667 22.1666 16.9867 22.1666H11.0133C9.33333 22.1666 9.08833 22.8899 8.79666 23.7649L8.56333 24.4649C8.34166 25.1299 8.16666 25.6666 6.90666 25.6666H4.71333C3.31333 25.6666 2.21666 24.4883 2.345 23.1233L2.99833 16.0183C3.16166 14.2683 3.5 12.8333 6.55666 12.8333H21.4433C24.5 12.8333 24.8383 14.2683 25.0017 16.0183L25.655 23.1233Z",
    stroke: "#06C7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 9.33325H3.5",
    stroke: "#06C7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9.33325H23.3333",
    stroke: "#06C7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5V5.83333",
    stroke: "#06C7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.83325H15.75",
    stroke: "#06C7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.5H10.5",
    stroke: "#06C7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5H21",
    stroke: "#06C7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDashboard);
export default __webpack_public_path__ + "static/media/car-dashboard.b912e83bd16673b1fe15be394a627d75.svg";
export { ForwardRef as ReactComponent };